import React, { Component } from 'react';

const KeepSessionPage = ({ authContext }) => {
  const auth = authContext.isAuthenticated();
  const name = auth ? '' : '';
  return <div className="">updated</div>;
};

export default KeepSessionPage;
